import type {
  FetchBaseQueryError,
  FetchBaseQueryMeta,
  QueryReturnValue,
} from "@reduxjs/toolkit/query";
import { removeHash } from "../lib/crypto";

export function defaultHeaders(headers: Headers, token?: string) {
  const defaultHeader: Headers = headers;

  if (token) {
    defaultHeader.set("Authorization", `Bearer ${token}`);
  }

  defaultHeader.set("ngrok-skip-browser-warning", "true");

  const productType = localStorage.getItem("product-type");
  const productId = productType ? removeHash(JSON.parse(productType)) : 21;

  defaultHeader.set("productId", productId?.toString() as string);

  return defaultHeader;
}

export async function defaultErrorMsg(
  result: QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta>
) {
  if (result.error) {
    console.log("Unauthorized Log", result);
  }
  if (
    result.error &&
    result.error?.status === 401
    // (result?.error?.data as any)?.message === "Unauthorized"
  ) {
    try {
      localStorage.clear();
    } catch (err) {
      console.error("Logout failed:", err);
    }
  }
}
